
<div class="config-dns-wrap">
  <div class="heading-n-desc-wrap">
    <div class="main-heading-wrap">
      <h3 class="main-heading">Setup CNAME and TXT records</h3>
    </div>

    <div class="main-desc-wrap">
      <p class="main-desc">
        This is a one-time setup and should take no longer than 15 minutes of
        your time.
      </p>
    </div>
  </div>

  <div class="content-wrap">
    <div>
      <h3 class="url-heading">Staging environment URL:</h3>

      <div class="cname-n-txt-wrap">
        <div class="cname-wrap">
          <h5 class="cname-heading">CNAME</h5>

          <p class="cname-desc-wrap">
            <span class="cname-desc-one"
              >CNAME for testing.keap.com should point to:
            </span>
            <span class="cname-desc-two">staging.builder.convrrt.com</span>
          </p>
        </div>

        <div class="txt-wrap">
          <h5 class="txt-heading">TXT RECORD</h5>

          <p class="txt-desc-wrap">
            <span class="txt-desc-one"
              >Hostname pre-validation TXT name:
            </span>
            <span class="txt-desc-two"
              >_cf-custom-hostname.testing.keap.com</span
            >
          </p>

          <p class="txt-desc-wrap">
            <span class="txt-desc-one"
              >Hostname pre-validation TXT value:
            </span>
            <span class="txt-desc-two"
              >ca3-7906e5fa540e4c91a183e98cf31cb471</span
            >
          </p>
        </div>
      </div>
    </div>

    <div>
      <h3 class="url-heading">Production environment URL:</h3>

      <div class="cname-n-txt-wrap">
        <div class="cname-wrap">
          <h5 class="cname-heading">CNAME</h5>

          <p class="cname-desc-wrap">
            <span class="cname-desc-one"
              >CNAME for testing.keap.com should point to:
            </span>
            <span class="cname-desc-two">staging.builder.convrrt.com</span>
          </p>
        </div>

        <div class="txt-wrap">
          <h5 class="txt-heading">TXT RECORD</h5>

          <p class="txt-desc-wrap">
            <span class="txt-desc-one"
              >Hostname pre-validation TXT name:
            </span>
            <span class="txt-desc-two"
              >_cf-custom-hostname.testing.keap.com</span
            >
          </p>

          <p class="txt-desc-wrap">
            <span class="txt-desc-one"
              >Hostname pre-validation TXT value:
            </span>
            <span class="txt-desc-two"
              >ca3-7906e5fa540e4c91a183e98cf31cb471</span
            >
          </p>
        </div>
      </div>
    </div>

    <div>
      <h3 class="url-heading">Custom CDN URL:</h3>

      <div class="cname-n-txt-wrap">
        <div class="cname-wrap">
          <h5 class="cname-heading">CNAME</h5>

          <p class="cname-desc-wrap">
            <span class="cname-desc-one"
              >CNAME for testing.keap.com should point to:
            </span>
            <span class="cname-desc-two">staging.builder.convrrt.com</span>
          </p>
        </div>

        <div class="txt-wrap">
          <h5 class="txt-heading">TXT RECORD</h5>

          <p class="txt-desc-wrap">
            <span class="txt-desc-one"
              >Hostname pre-validation TXT name:
            </span>
            <span class="txt-desc-two"
              >_cf-custom-hostname.testing.keap.com</span
            >
          </p>

          <p class="txt-desc-wrap">
            <span class="txt-desc-one"
              >Hostname pre-validation TXT value:
            </span>
            <span class="txt-desc-two"
              >ca3-7906e5fa540e4c91a183e98cf31cb471</span
            >
          </p>
        </div>
      </div>
    </div>

    <div class="verify-c-domains-wrap">
      <h3 class="sub-heading">Before clicking the VERIFY CUSTOM HOSTNAMES</h3>
      <a class="check-dns-link" href="#">CHECK DNS STATUS</a>
    </div>

    <div class="verify-btn-wrap">
      <cvt-button
        :color="''"
        :mode="'LIGHT'"
        :text="'Verify Custom Hostnames'"
        :special-padding="'20px 171px'"
        @click="verifyCustomHostnames"
      >
      </cvt-button>
    </div>
  </div>
</div>
